/**
 * 로컬·개발·스테이지·운영 모두 `/`에서 리뉴얼을 연다.
 * `/renewal`은 같은 주소로 보낸다.
 */
export const RENEWAL_AT_ROOT = true

export const RENEWAL_BASE = RENEWAL_AT_ROOT ? '' : '/renewal'

export const ASSET = '/renewal-assets'

export function renewalPath(subpath = '/'): string {
  if (subpath === '/' || subpath === '') return RENEWAL_BASE || '/'
  const clean = subpath.replace(/\/$/, '')
  const suffix = clean.startsWith('/') ? clean : `/${clean}`
  const path = `${RENEWAL_BASE}${suffix}`
  if (path.includes(':')) return path
  return path.endsWith('/') ? path : `${path}/`
}

export const LOGIN_PATH = '/auth/login'

export const APPLY_LOGIN = `${LOGIN_PATH}?utm_source=br_landing&utm_medium=cta&utm_campaign=${encodeURIComponent(
  '브라우니 랜딩 페이지'
)}&utm_content=home_hero&utm_term=${encodeURIComponent('서비스신청')}&utm_id=logout`

export const FOOTER_APPLY = `${LOGIN_PATH}?utm_source=br_landing&utm_medium=cta&utm_campaign=${encodeURIComponent(
  '브라우니 랜딩 페이지'
)}&utm_content=footer_foot&utm_term=${encodeURIComponent('서비스신청')}&utm_id=logout`
